/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_SavedInputs */

const en_us2_workout_quick_saved = /** @type {(inputs: Workout_Quick_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout logged`)
};

const pt_br2_workout_quick_saved = /** @type {(inputs: Workout_Quick_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino registrado`)
};

const es_419_workout_quick_saved = /** @type {(inputs: Workout_Quick_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenamiento registrado`)
};

const pt_pt2_workout_quick_saved = /** @type {(inputs: Workout_Quick_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino registado`)
};

const fr_fr2_workout_quick_saved = /** @type {(inputs: Workout_Quick_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séance enregistrée`)
};

const de_de2_workout_quick_saved = /** @type {(inputs: Workout_Quick_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training eingetragen`)
};

const it_it2_workout_quick_saved = /** @type {(inputs: Workout_Quick_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamento registrato`)
};

/**
* | output |
* | --- |
* | "Workout logged" |
*
* @param {Workout_Quick_SavedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_saved = /** @type {((inputs?: Workout_Quick_SavedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_SavedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_saved(inputs)
	if (locale === "es-419") return es_419_workout_quick_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_saved(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_saved(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_saved(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_saved(inputs)
	return en_us2_workout_quick_saved(inputs)
});
export { workout_quick_saved as "workout-quick.saved" }